import Animation from '../classes/Animation';
import GSAP from 'gsap';

export default class Scale extends Animation {
  constructor({ element, elements }) {
    super({ element, elements });

    // --- NEW ---
    // 1. Create a matchMedia instance

    // 3. Create the tween here, but leave it paused
    // This tween will ONLY exist on viewports > 1024px
    this.scaleTween = GSAP.to(this.element, {
      scale: 1,
      duration: 0.8,
      ease: 'power3.out',
      delay: 0.2,
      paused: true, // <-- Create it in a paused state
    });

    // Return a cleanup function
    return () => {
      this.scaleTween?.kill(); // Kill the tween if the media query no longer matches
    };

    // --- END NEW ---
  }

  animateIn() {
    this.scaleTween?.play();
  }

  animateOut() {
    // Optional: You could reverse the animation if needed
    // this.scaleTween?.reverse();
  }
}
